<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="field-value">
      <BaseIcon
        v-if="isLoading"
        icon="spinner"
        class="spinner"
      />
      {{ formattedValue }}
    </div>
  </div>
</template>

<script>
import { toRefs, computed } from '@nuxtjs/composition-api'
import useDynamicOptions from '@/composables/useDynamicOptions'

export default {
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: '',
    },
    question: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { question, value } = toRefs(props)
    const dynamicOptions = computed(() => {
      return question?.value?.config?.dynamicOptions || {}
    })
    const hasDynamicOptions = computed(() => {
      return dynamicOptions.value && dynamicOptions.value.enabled
    })
    const { isLoading, fetchOptionsFromIntegrationAttributeMappings, getDisplayValues } = useDynamicOptions(dynamicOptions)

    if (hasDynamicOptions.value) {
      fetchOptionsFromIntegrationAttributeMappings()
    }

    const displayValue = hasDynamicOptions.value
      ? computed(() => getDisplayValues(value.value))
      : computed(() => value.value)

    return {
      displayValue,
      isLoading,
    }
  },
  computed: {
    formattedValue() {
      if (Array.isArray(this.displayValue)) {
        return this.displayValue.length
          ? this.displayValue.join(', ')
          : this.emptyValuePlaceholder
      }
      if (typeof this.displayValue === 'boolean') return this.value ? 'Yes' : 'No'
      if (this.displayValue === null || this.displayValue === undefined || this.displayValue === '')
        return this.emptyValuePlaceholder
      else return this.displayValue
    },
    emptyValuePlaceholder() {
      return (
        this.question?.config?.emptyValuePlaceholder ||
        this.question?.config?.default?.value ||
        '-'
      )
    },
  },
}
</script>
